import { render, staticRenderFns } from "./CreateCource.vue?vue&type=template&id=e5ee7ce4&scoped=true"
import script from "./CreateCource.vue?vue&type=script&lang=js"
export * from "./CreateCource.vue?vue&type=script&lang=js"
import style0 from "./CreateCource.vue?vue&type=style&index=0&id=e5ee7ce4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ee7ce4",
  null
  
)

export default component.exports